module.exports = __webpack_public_path__ + "static/media/1013278.57ac17bb.png";